module.exports = __webpack_public_path__ + "img/banner.f1dca277.jpg";